import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDown, Info } from 'lucide-react'

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { cn } from '@/lib/utils'

const RULE_KEYS = [
    'pin_precedence_first',
    'pin_precedence_specificity',
    'pin_precedence_and',
    'pin_precedence_tie',
    'pin_precedence_no_match',
]

const EXAMPLE_KEYS = [
    'pin_precedence_example_low',
    'pin_precedence_example_other_bin',
    'pin_precedence_example_match',
    'pin_precedence_example_none',
]

const PANEL_CLASSES =
    'border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-800 dark:bg-blue-950/30 dark:text-blue-200'

/** Explains that a matching routing pin beats the weights. Collapsed by default: reference material,
 *  not something the merchant needs on screen while setting percentages. */
export const RoutingPrecedenceHelp = () => {
    const { t } = useTranslation('paymentFlows')
    const [open, setOpen] = useState(false)

    return (
        <Collapsible open={open} onOpenChange={setOpen}>
            <CollapsibleTrigger
                className={cn(
                    'flex w-full items-center gap-2 rounded-md border px-3 py-2 text-[11px] font-medium transition-colors hover:brightness-95',
                    PANEL_CLASSES,
                )}
            >
                <Info className="size-3 shrink-0" />
                <span className="flex-1 text-left">{t('form.sections.pin_precedence')}</span>
                <ChevronDown className={cn('size-3 shrink-0 transition-transform', open && 'rotate-180')} />
            </CollapsibleTrigger>
            <CollapsibleContent>
                <div className={cn('mt-1.5 space-y-1.5 rounded-md border px-3 py-2 text-[11px]', PANEL_CLASSES)}>
                    <ul className="list-disc space-y-0.5 pl-3.5">
                        {RULE_KEYS.map((key) => (
                            <li key={key}>{t(`form.fields.weight.${key}`)}</li>
                        ))}
                    </ul>
                    <p className="font-medium">{t('form.fields.weight.pin_precedence_example_title')}</p>
                    <p>{t('form.fields.weight.pin_precedence_example_setup')}</p>
                    <ul className="list-disc space-y-0.5 pl-3.5">
                        {EXAMPLE_KEYS.map((key) => (
                            <li key={key}>{t(`form.fields.weight.${key}`)}</li>
                        ))}
                    </ul>
                </div>
            </CollapsibleContent>
        </Collapsible>
    )
}
